:host {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.mb-chips-list {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  padding-left: 8px;
}

.mb-chips-qds-chip {
  margin-right: 8px;
  --qds-control-small-height: 1.75rem;
  --qds-control-small-icon-size: 0.5rem;
}
